import firebase from "@/firebase";
import util from "@/util";
export default {
  namespaced: true,
  state: {
    tested: 5,
    goal: 5,
    percent: 6,
    oz: 0,
    vol: 0,
    type: {
      name: "bleach",
    },
    types: [
      {
        name: "bleach",
      },
      {
        name: "trichlor",
        multiplier: 6854.95,
      },
      {
        name: "dichlor",
        volume: 0.9351,
        multiplier: 4149.03,
      },
      {
        name: "cal-hypo 48%",
        volume: 0.9352,
        multiplier: 3565.44,
      },
      {
        name: "cal-hypo 53%",
        volume: 0.9352,
        multiplier: 3936.84,
      },
      {
        name: "cal-hypo 65%",
        volume: 0.9352,
        multiplier: 4828.12,
      },
      {
        name: "cal-hypo 73%",
        volume: 0.9352,
        multiplier: 5422.41,
      },
      {
        name: "lithium-hypo",
        volume: 0.978,
        multiplier: 2637.5,
      },
      {
        name: "chlorine gas",
        multiplier: 7489.4,
      },
    ],
    jugSize: { value: 64, name: "64 fl oz" },
    jugSizes: [
      { value: 30, name: "30 fl oz" },
      { value: 64, name: "64 fl oz" },
      { value: 96, name: "96 fl oz" },
      { value: 121, name: "121 fl oz" },
      { value: 128, name: "128 fl oz" },
      { value: 174, name: "174 fl oz" },
      { value: 182, name: "182 fl oz" },
    ],
    allJugSizes: {
      "U.S.": [
        { value: 30, name: "30 fl oz" },
        { value: 64, name: "64 fl oz" },
        { value: 96, name: "96 fl oz" },
        { value: 121, name: "121 fl oz" },
        { value: 128, name: "128 fl oz" },
        { value: 174, name: "174 fl oz" },
        { value: 182, name: "182 fl oz" },
      ],
      Metric: [
        { value: 900, name: "900 ml" },
        { value: 2000, name: "2.0 l" },
        { value: 2800, name: "2.0 l" },
        { value: 3600, name: "3.6 l" },
        { value: 3800, name: "3.8 l" },
        { value: 5100, name: "5.1 l" },
        { value: 5400, name: "5.4 l" },
      ],
      Imperial: [
        { value: 30, name: "30 fl oz" },
        { value: 64, name: "64 fl oz" },
        { value: 96, name: "96 fl oz" },
        { value: 121, name: "121 fl oz" },
        { value: 128, name: "128 fl oz" },
        { value: 174, name: "174 fl oz" },
        { value: 182, name: "182 fl oz" },
      ],
    },
  },
  getters: {
    getFC(state) {
      return state;
    },
  },
  mutations: {
    calcFC(state, settings) {
      const gallons = util.getGallons(settings.volume, settings.unitType);
      let temp = (state.goal - state.tested) * gallons;
      if (state.tested < state.goal) {
        if (state.type.name === "bleach") {
          temp = ((temp / 482.202) * 6) / state.percent;
          state.vol = util.getVolume(temp, settings.unitType);
          state.oz = 0;
        } else {
          state.vol = 0;
          temp = temp / state.type.multiplier;
          if (
            state.type.name !== "trichlor" &&
            state.type.name !== "chlorine gas"
          ) {
            state.vol = util.getVolume(
              temp * state.type.volume,
              settings.unitType
            );
          }
          state.oz = util.getWeight(temp, settings.unitType);
        }
      } else {
        state.oz = state.vol = 0;
      }
      return state;
    },
    setFC(state, fc) {
      if (!fc) {
        return;
      }
      state.tested = Number(fc.tested) || Number(state.tested);
      state.goal = Number(fc.goal) || Number(state.goal);
      state.oz = fc.oz || state.oz;
      state.vol = fc.vol || state.vol;
      state.type = fc.type || state.type;
      state.percent = Number(fc.percent) || Number(state.percent);
      state.jugSize = fc.jugSize || state.jugSize;
    },
  },
  actions: {
    async initFC(state) {
      if (!firebase.auth.currentUser) return;
      const doc = await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("fc")
        .get();
      const fc = doc.data();
      state.commit("setFC", fc);
    },
    async saveFC(state, data) {
      if (!firebase.auth.currentUser) return;
      await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("fc")
        .set({
          tested: data.tested,
          goal: data.goal,
          oz: data.oz,
          vol: data.vol,
          type: data.type,
          percent: data.percent,
          jugSize: data.jugSize,
        });
      state.commit("setFC", data);
    },
  },
};
